import debounce from 'lodash/debounce';

// https://css-tricks.com/debouncing-throttling-explained-examples/
// https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
/**
 * Utility function which registers a ResizeObserver that will run a CB on any resize
 * event on the registered DOM node (in this case the Pane that the map is in)
 * The CB function here is a lodash debounced function which calls Map Box map.resize.
 * Note: @param trailing - this tells the debounced function to run on the last resize.
 * @param {*} mapResize
 */
function registerMapResizer(mapResize) {
  const debouncedResized = debounce(() => mapResize(), 50, { trailing: true });
  const myObserver = new ResizeObserver(() => {
    debouncedResized();
  });
  // Using query selector here b/c getting a ref here would be more convoluted
  const mapPaneNode = document.querySelector('.Pane.vertical.Pane1');
  myObserver.observe(mapPaneNode);
}

export { registerMapResizer };
